import { useState } from "react";
import ComDatePicker from "./../../Components/ComDatePicker/ComDatePicker";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import ComInput from "../../Components/ComInput/ComInput";
import ComSelect from "./../../Components/ComInput/ComSelect copy";
import ComUpImgOne from "./../../Components/ComUpImg/ComUpImgOne";
import { useStorage } from "../../hooks/useLocalStorage";
import { firebaseImg } from "./../../upImgFirebase/firebaseImg";
import { putData } from "../../api/api";
import { useNotification } from "../../Notification/Notification";
import { useNavigate } from "react-router-dom";
const ProfileForm = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [user, setUser] = useStorage("use", null);
  const [disabled, setDisabled] = useState(false);
  const [image, setImages] = useState(null);
  const { notificationApi } = useNotification();
  const navigate = useNavigate();
  const Messenger = yup.object({
    firstName: yup
      .string()
      .required("Please enter your first name")
      .min(2, "Name is too short, minimum 2 characters required")
      .max(50, "Name is too long, maximum 50 characters allowed"),
    lastName: yup
      .string()
      .required("Please enter your first name")
      .min(2, "Name is too short, minimum 2 characters required")
      .max(50, "Name is too long, maximum 50 characters allowed"),
  });
  const methods = useForm({
    resolver: yupResolver(Messenger),
    values: user,
  });
  const { handleSubmit, register, setFocus, watch, setValue, setError } =
    methods;

  const onSubmit = (data) => {
    setDisabled(true);
    const formData = new FormData();
    formData.append("image", image);
    console.log(image);
    for (const key in data) {
      formData.append(key, data[key]);
    }

    putData(`/accounts`, user?.id, data)
      .then((e) => {
        notificationApi("success", "Profile updated successfully", "Updated");
        setUser(data);
        if (image) {
          putData(`/accounts`, "avatar", formData)
            .then((e) => {
              setUser(e);
              notificationApi(
                "success",
                "Avatar updated successfully",
                "Updated"
              );
              console.log(e);
              setTimeout(() => {
                navigate("/");
              }, 1000);
            })
            .catch((e) => {
              console.log(e);
              notificationApi(
                "error",
                "Avatar update failed",
                "Avatar update unsuccessful"
              );
            });
        }
        setDisabled(false);
      })
      .catch((e) => {
        console.log(e);
        setDisabled(false);
        notificationApi(
          "error",
          "Profile update failed",
          "Update unsuccessful"
        );
      });
  };

  const onChange = (data) => {
    const selectedImages = data;
    console.log(selectedImages);
    setImages(selectedImages);
  };

  return (
    <div className="flex-1 px-4 py-0">
      <h1 className="text-2xl font-bold mb-6">My Profile</h1>
      <div className="w-48 h-50 flex justify-center items-center pl-8">
        {!isEditing ? (
          <img
            className="h-40 w-40 rounded-full border border-gray-400 object-cover"
            src={`${user.avatar}`}
            key={user.avatar}
            alt="Avatar"
          />
        ) : (
          <div className="flex flex-col justify-center gap-2 items-center">
            <ComUpImgOne
              className="rounded-2xl border border-gray-400"
              imgUrl={user.avatar}
              onChange={onChange}
            />
            <span className="text-xs text-gray-400 text-center">
              Click on the image to change the profile picture
            </span>
          </div>
        )}
      </div>
      <div className="flex">
        <FormProvider {...methods}>
          {isEditing ? (
            <form className="flex-1 mr-8" onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-4">
                <ComInput
                  type="text"
                  label={"First Name"}
                  placeholder={"Please enter your full name"}
                  readOnly={!isEditing}
                  required={isEditing}
                  {...register("firstName")}
                />
              </div>
              <div className="mb-4">
                <ComInput
                  type="text"
                  label={"Last Name"}
                  placeholder={"Please enter your full name"}
                  readOnly={!isEditing}
                  required={isEditing}
                  {...register("lastName")}
                />
              </div>
              <div className="mb-4">
                <ComInput
                  placeholder="Enter email"
                  label="Email"
                  type="text"
                  readOnly={!isEditing}
                  required={isEditing}
                  {...register("email")}
                />
              </div>
              <div className="mb-4">
                <ComInput
                  placeholder="Enter phone number"
                  label="Phone Number"
                  type="numbers"
                  maxLength={10}
                  {...register("phoneNumber")}
                  disabled={isEditing}
                  readOnly={!isEditing}
                />
              </div>
              <div className="mb-4">
                <ComSelect
                  size={"large"}
                  style={{
                    width: "100%",
                  }}
                  label="Gender"
                  placeholder="Gender"
                  onChangeValue={(e, value) => {
                    if (value.length === 0) {
                      setValue("gender", null, { shouldValidate: true });
                    } else {
                      setValue("gender", value, { shouldValidate: true });
                    }
                  }}
                  value={watch("gender")}
                  mode="default"
                  options={[
                    {
                      value: "Male",
                      label: `Male`,
                    },
                    {
                      value: "Female",
                      label: `Female`,
                    },
                  ]}
                  required={isEditing}
                  {...register("gender")}
                />
              </div>

              <div className="mb-6">
                <div className="relative">
                  <ComDatePicker
                    type="numbers"
                    label={"Date of Birth"}
                    placeholder={"Please enter your date of birth"}
                    {...register("dateOfBirth")}
                    required={isEditing}
                  />
                </div>
              </div>

              <div className="flex justify-center">
                <button
                  type="submit"
                  className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
                >
                  Update
                </button>
              </div>
            </form>
          ) : (
            <form className="flex-1 mr-8" onSubmit={handleSubmit(() => {})}>
              <div className="mb-4">
                <ComInput
                  type="text"
                  label={"First Name"}
                  placeholder={"Please enter your full name"}
                  readOnly={!isEditing}
                  required={isEditing}
                  {...register("firstName")}
                />
              </div>
              <div className="mb-4">
                <ComInput
                  type="text"
                  label={"Last Name"}
                  placeholder={"Please enter your full name"}
                  readOnly={!isEditing}
                  required={isEditing}
                  {...register("lastName")}
                />
              </div>
              <div className="mb-4">
                <ComInput
                  placeholder="Enter email"
                  label="Email"
                  type="text"
                  readOnly={!isEditing}
                  required={isEditing}
                  {...register("email")}
                />
              </div>
              <div className="mb-4">
                <ComInput
                  placeholder="Enter phone number"
                  label="Phone Number"
                  type="numbers"
                  maxLength={10}
                  {...register("phoneNumber")}
                  disabled={isEditing}
                  readOnly={!isEditing}
                />
              </div>
              <div className="mb-4">
                <ComSelect
                  size={"large"}
                  style={{
                    width: "100%",
                  }}
                  label="Gender"
                  placeholder="Gender"
                  onChangeValue={(e, value) => {
                    if (value.length === 0) {
                      setValue("gender", null, { shouldValidate: true });
                    } else {
                      setValue("gender", value, { shouldValidate: true });
                    }
                  }}
                  value={watch("gender")}
                  mode="default"
                  options={[
                    {
                      value: "Male",
                      label: `Male`,
                    },
                    {
                      value: "Female",
                      label: `Female`,
                    },
                  ]}
                  readOnly={!isEditing}
                  required={isEditing}
                  open={false}
                  {...register("gender")}
                />
              </div>

              <div className="mb-6">
                <div className="relative">
                  <ComDatePicker
                    type="numbers"
                    disabledDate={false}
                    open={false}
                    readOnly={!isEditing}
                    label={"Date of Birth"}
                    placeholder={"Please enter your date of birth"}
                    {...register("dateOfBirth")}
                    required={isEditing}
                  />
                </div>
              </div>
            </form>
          )}
        </FormProvider>
      </div>
      {!isEditing && (
        <div className="flex justify-center">
          <button
            type="button"
            onClick={() => {
              setIsEditing(true);
              setFocus("fullname");
            }}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
          >
            Update Profile
          </button>
        </div>
      )}
    </div>
  );
};

export default function ProfilePage() {
  const [activeSection, setActiveSection] = useState("profile");

  return (
    <div>
      <div className="col-span-3">
        <div className="mb-4 bg-white border border-gray-300 rounded-lg shadow-sm 2xl:col-span-1 sm:px-6 sm:py-4 mt-2">
          <ProfileForm />
        </div>
      </div>
    </div>
  );
}

